module.exports = __webpack_public_path__ + "assets/images/rideCenter-8d070e9015eb7cabe962c0ce88befd60.mp4";